import { colors } from "@/lib/theme";

/**
 * Training palette, derived from the app's design tokens.
 *
 * The demo build carried its own navy palette (#0B2D4D) copied from an HTML
 * mockup. That made training look like a different product and broke the rule
 * that every colour comes from `lib/theme.ts`. The key names are kept so the
 * ported screens didn't all need rewriting, but every value now resolves to a
 * real brand token.
 */
export const courseTheme = {
    /** Deep brand ground for hero cards, replacing the old navy. */
    navy: colors.teal700,
    navySoft: colors.teal600,

    teal: colors.teal500,
    tealD: colors.teal600,
    tealL: colors.teal400,
    tealTint: colors.teal50,
    tealTint2: colors.teal100,

    green: colors.success500,
    greenTint: colors.success50,
    red: "#E5484D",
    redTint: "#FCEBEB",
    amber: colors.warning500,
    amberTint: colors.warning50,

    /** Muted text + hairlines. */
    slate: "#5F6B7A",
    slateL: "#93A0AD",
    line: "#E6EBEF",
    paper: "#F7F9FA",
    white: "#FFFFFF"
} as const;

/**
 * Card elevation, tinted to the brand ink rather than navy. React Native has no
 * negative shadow spread, so these approximate the source design.
 */
export const courseShadow = {
    card: {
        shadowColor: colors.ink,
        shadowOpacity: 0.12,
        shadowRadius: 12,
        shadowOffset: { width: 0, height: 6 },
        elevation: 4
    },
    deep: {
        shadowColor: colors.ink,
        shadowOpacity: 0.2,
        shadowRadius: 20,
        shadowOffset: { width: 0, height: 14 },
        elevation: 8
    }
} as const;
